import { createSlice } from "@reduxjs/toolkit";
import * as MiLibraryApi from "../api/mi-library";

const miLibrarySlice = createSlice({
  name: "miLibrary",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      const docs = action.payload?.docs ?? action.payload?.assets ?? [];
      const summary =
        action.payload?.summary ??
        action.payload?.pagination ?? {
          count: docs.length,
          hasNextPage: false,
        };

      state.list = docs;
      state.summary = summary;
      state.loading = false;
    },
    addMiLibrarySuccess: (state, action) => {
      state.list = [action.payload, ...(state.list ?? [])];
      if (state.summary) {
        state.summary = {
          ...state.summary,
          count: (state.summary.count ?? 0) + 1,
        };
      }
    },
    updateMiLibrarySuccess: (state, action) => {
      state.list = (state.list ?? []).map((item) =>
        item._id === action.payload._id ? action.payload : item
      );
    },
    deleteMiLibrarySuccess: (state, action) => {
      state.list = (state.list ?? []).filter(
        (item) => item._id !== action.payload?._id
      );
      if (state.summary) {
        state.summary = {
          ...state.summary,
          count: Math.max((state.summary.count ?? 1) - 1, 0),
        };
      }
    },
  },
});

export const getMiLibraryList = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await MiLibraryApi.getMiLibraryList(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = miLibrarySlice;
export const {
  setLoading,
  setError,
  getListSuccess,
  addMiLibrarySuccess,
  updateMiLibrarySuccess,
  deleteMiLibrarySuccess,
} = actions;
export default reducer;
